import { render, staticRenderFns } from "./ReviewOrder.vue?vue&type=template&id=041fb015&scoped=true&"
import script from "./ReviewOrder.vue?vue&type=script&lang=js&"
export * from "./ReviewOrder.vue?vue&type=script&lang=js&"
import style0 from "./ReviewOrder.vue?vue&type=style&index=0&id=041fb015&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041fb015",
  null
  
)

export default component.exports